import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {

  constructor(private keycloakService: Keycloak) {}

  public logout(): void {
    localStorage.removeItem('wind-custom-default-module');
    this.keycloakService.logout({redirectUri: window.location.origin});
  }

}
